import React, { useState, useEffect} from "react";
import { 
  TournamentEvent, TournamentEventState, 
  ApiTournamentEvent, EventLocation,
  TranslationEventState
} from "../../types";
import { getListEventLocations } from "../../api";
import { Button } from "../common/Button";


interface ConfigEventForm {
  event: TournamentEvent, 
  onSave: (newEvent: Partial<ApiTournamentEvent>) => Promise<void>
  onCancel: () => void
}
export const TournamentEventForm: React.FC<ConfigEventForm> = ({event, onSave, onCancel}) => {
  const [state, setState] = useState(event.state);
  const [date, setDate] = useState(event.date ?? new Date().toLocaleDateString("en-CA").slice(0, 10));
  const [time, setTime] = useState(event.time ?? "21:00");
  const [tournament_points, setTournamentPoints] = useState(event.tournament_points ?? event.season.default_tournament_points);
  const [location_id, setLocationId] = useState(event.location?.id ?? null);
  const [locations, setLocations] = useState<EventLocation[]>([]);
  const listState: TournamentEventState[] = ['da_programmare', 'da_confermare', 'confermato', 'in_corso', 'concluso'];
  
  // Carica lista
  useEffect(() => {
    const fetchItems = async () => {
      const data = await getListEventLocations();
      setLocations(data);
      if (!event.location?.id && data.length > 0) {
        setLocationId((currentLocationId) => currentLocationId ?? data[0].id);
      }
    };

    fetchItems();
  }, [event.location?.id]);

  const handleSaveEvent = () => {
    let new_state = state;
    if (
      state === "da_programmare"
      && location_id
      && date
      && time
      && tournament_points >= 0
    ) {
      new_state = "da_confermare";
    }
    const newEvent: Partial<ApiTournamentEvent> = {
      state: new_state,
      date: date,
      time: time,
      tournament_points: tournament_points,
      location_id: location_id,
    }
    onSave(newEvent);
    // setState(new_state);
    
  };

  return (
    <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50">
      <div className="fixed inset-0 z-50 flex justify-center items-end bg-black/50">
        <div className="bg-white rounded-t-xl w-full max-w-md p-6 animate-slideUp">
          <h3 className="text-lg font-bold mb-4">
            Info Generali
          </h3>
          <div>
            <label className="block">
                Stato
              <select
                    className="w-full border border-gray-300 px-2 py-1 rounded"
                    onChange={(e) => setState(e.target.value as TournamentEventState)}
                    value={state}
                >
                  {listState.map((state) => (
                    <option key={state} value={state}>
                      { TranslationEventState[state] }
                    </option>
                  ))}
                </select>
            </label>
            <label className="block">
                Data
                <input
                    type="date"
                    className="w-full border border-gray-300 px-2 py-1 rounded"
                    onChange={(e) => setDate(e.target.value)}
                    value={date}
                />
            </label>
            <label className="block">
                Ora inzio
                <input
                    type="time"
                    className="w-full border border-gray-300 px-2 py-1 rounded"
                    onChange={(e) => setTime(e.target.value)}
                    value={time}
                />
            </label>
            <label className="block">
                Punteggio massimo
                <input
                    type="number"
                    className="w-full border border-gray-300 px-2 py-1 rounded"
                    onChange={(e) => setTournamentPoints(Number(e.target.value))}
                    value={tournament_points}
                />
            </label>
            <label className="block">
                Luogo
                <select
                    className="w-full border border-gray-300 px-2 py-1 rounded"
                    onChange={(e) => setLocationId(Number(e.target.value))}
                    value={location_id}
                >
                  {locations.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.name}
                    </option>
                  ))}
                </select>
            </label>
          </div>
          <div className="flex justify-between space-x-2 mt-4">
            <Button variant="secondary" onClick={onCancel}>
              Annulla
            </Button>
            <Button 
              variant="primary"
              onClick={() => handleSaveEvent()}
            >Salva</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
